import { Interface } from '@ethersproject/abi';
import GAS_STATION_ABI from './gas-station.json';

const GAS_STATION_INTERFACE = new Interface(GAS_STATION_ABI);

export { GAS_STATION_INTERFACE, GAS_STATION_ABI };
